import { c as _c } from "react/compiler-runtime";
import React from "react";
export interface PropertyImpact {
  propertyPath: string;
  type: string;
  renderImpact: string;
  missingBehavior: string;
}
interface FixturePropertyImpactTableProps {
  properties: PropertyImpact[];
  title?: string;
}

/**
 * A functional component for rendering a table that displays property impact analysis.
 * Shows how properties affect rendering and their behavior when missing.
 *
 * @param {Object} props - The props for the component.
 * @param {Array<PropertyImpact>} props.properties - An array of objects representing property impact information.
 * @param {string} [props.title] - An optional title for the table.
 *
 * @returns {JSX.Element} A table displaying property paths, types, render impact, and missing behavior.
 */
export const FixturePropertyImpactTable = t0 => {
  const $ = _c(10);
  const {
    properties,
    title
  } = t0;
  const t1 = title ?? "\u0414\u0435\u0442\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u043B\u0438\u044F\u043D\u0438\u0435 \u0442\u0438\u043F\u043E\u0432 \u043D\u0430 \u0440\u0435\u043D\u0434\u0435\u0440\u0438\u043D\u0433";
  let t2;
  if ($[0] !== t1) {
    t2 = <h3 className="text-base font-semibold tracking-tight">{t1}</h3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <thead className="border-b bg-muted/50 text-xs font-medium tracking-wide uppercase"><tr className="font-semibold"><th className="px-4 py-3" scope="col">Путь к свойству</th><th className="px-4 py-3" scope="col">Тип</th><th className="px-4 py-3" scope="col">Влияние на рендеринг</th><th className="px-4 py-3" scope="col">Поведение при отсутствии</th></tr></thead>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== properties) {
    t4 = properties.map(_temp);
    $[3] = properties;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="overflow-x-auto rounded-sm border"><table className="max-w-full table-fixed text-left text-sm md:text-base">{t3}<tbody className="divide-y">{t4}</tbody></table></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t5) {
    t6 = <div className="flex w-full flex-col gap-4">{t2}{t5}</div>;
    $[7] = t2;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
function _temp(prop, index) {
  return <tr key={`${prop.propertyPath}-${index}`} className="transition-colors hover:bg-muted/20"><td className="px-4 py-3 font-mono text-xs md:text-sm">{prop.propertyPath}</td><td className="px-4 py-3 font-mono text-xs md:text-sm">{prop.type}</td><td className="px-4 py-3 text-sm text-muted-foreground">{prop.renderImpact}</td><td className="px-4 py-3 text-sm text-muted-foreground">{prop.missingBehavior}</td></tr>;
}